import { Head } from "@inertiajs/react"

import { MainContainer } from "@/components/ui/container"
import { PageHeader } from "@/components/ui/headers"
import { StaffLayout } from "@/components/layouts/staff-layout"
import {
  DeliveryBoard,
  type CourierOption,
  type Delivery,
  type FailureReason,
} from "@/features/staff/delivery/delivery-board"
import { t } from "@/lib/i18n"

/**
 * The delivery board.
 *
 * Shows only what is still out: `delivered` and `failed` are filtered on the
 * server. A board is a list of work, and work that is finished is history —
 * it belongs in a report, not in the thing somebody scans during service.
 */

type Props = {
  deliveries: Delivery[]
  couriers: CourierOption[]
  failureReasons: FailureReason[]
  timeZone: string
  currency: string
}

export default function StaffLocationDeliveriesIndex({
  deliveries,
  couriers,
  failureReasons,
}: Props) {
  const title = t("ui.react.pages.staff.location.deliveries.index.page_title")

  return (
    <>
      <Head title={title} />

      <MainContainer size="md">
        <PageHeader
          title={title}
          description={t("ui.react.pages.staff.location.deliveries.index.page_description")}
        />

        <DeliveryBoard
          deliveries={deliveries}
          couriers={couriers}
          failureReasons={failureReasons}
        />
      </MainContainer>
    </>
  )
}

StaffLocationDeliveriesIndex.layout = (page: React.ReactNode) => <StaffLayout>{page}</StaffLayout>
